export class CloudEnvironment {
  customerId?: string;
  accountId?: string;
  environmentId?: string;
  connectAccountId?: string;
  creationTime?: Date;
  description?: string;
  emsServicePort?: string;
  isAvailable?: boolean;
  isEnabled?: boolean;
  inMaintenanceMode?: boolean;
  isProduction?: boolean;
  name?: string;
  region?: string;
  schemaName?: string;
  statusMessage?: string;
  version?: string;
  deploymentType?: string;
}
